<template>
    <div>
        <div class="topbar">

            <div class="tabs tabs-tertiary">
                <b-nav tabs>
                    <b-nav-item to="/ecosystems" exact>
                        Find Ecosystems
                    </b-nav-item>

                    <b-nav-item to="/ecosystems/my-ecosystems" exact>
                        My Ecosystems
                    </b-nav-item>
                </b-nav>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        current: String
    }
}
</script>

<style scoped>

</style>